import { types, Instance } from 'mobx-state-tree'

export const AnalyticsTotalStats = types.model('AnalyticsTotalStats', {
  key: types.maybe(types.string),
  count: types.maybe(types.string)
})

export interface IAnalyticsTotalStats extends Instance<typeof AnalyticsTotalStats> {}
export default AnalyticsTotalStats
